import { ConfigCatClient } from "./ConfigCatClient";
import { AutoPollOptions, ManualPollOptions, LazyLoadOptions } from "./ConfigCatClientOptions";
import { ConfigCatConsoleLogger } from "./ConfigCatLogger";
import { setupPolyfills } from "./Polyfills";
setupPolyfills();
/**
 * Create an instance of ConfigCatClient and setup AutoPoll mode
 * @param {string} apiKey - ApiKey to access your configuration.
 * @param config - Configuration for autoPoll mode
 */

export function createClientWithAutoPoll(apiKey, configCatKernel, options) {
  return new ConfigCatClient(new AutoPollOptions(apiKey, configCatKernel.sdkType, configCatKernel.sdkVersion, options, configCatKernel.cache), configCatKernel);
}
/**
 * Create an instance of ConfigCatClient and setup ManualPoll mode
 * @param {string} apiKey - ApiKey to access your configuration.
 * @param config - Configuration for manualPoll mode
 */

export function createClientWithManualPoll(apiKey, configCatKernel, options) {
  return new ConfigCatClient(new ManualPollOptions(apiKey, configCatKernel.sdkType, configCatKernel.sdkVersion, options, configCatKernel.cache), configCatKernel);
}
/**
 * Create an instance of ConfigCatClient and setup LazyLoad mode
 * @param {string} apiKey - ApiKey to access your configuration.
 * @param config - Configuration for lazyLoad mode
 */

export function createClientWithLazyLoad(apiKey, configCatKernel, options) {
  return new ConfigCatClient(new LazyLoadOptions(apiKey, configCatKernel.sdkType, configCatKernel.sdkVersion, options, configCatKernel.cache), configCatKernel);
}
/**
 * Create an instance of ConfigCatConsoleLogger
 * @param {LogLevel} logLevel - Specifies message's filtering to output for the CofigCatConsoleLogger.
 */

export function createConsoleLogger(logLevel) {
  return new ConfigCatConsoleLogger(logLevel);
}
export var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["Debug"] = 4] = "Debug";
  LogLevel[LogLevel["Info"] = 3] = "Info";
  LogLevel[LogLevel["Warn"] = 2] = "Warn";
  LogLevel[LogLevel["Error"] = 1] = "Error";
  LogLevel[LogLevel["Off"] = -1] = "Off";
})(LogLevel || (LogLevel = {}));

export var FetchStatus;

(function (FetchStatus) {
  FetchStatus[FetchStatus["Fetched"] = 0] = "Fetched";
  FetchStatus[FetchStatus["NotModified"] = 1] = "NotModified";
  FetchStatus[FetchStatus["Errored"] = 2] = "Errored";
})(FetchStatus || (FetchStatus = {}));

var FetchResult =
/** @class */
function () {
  function FetchResult(status, responseBody, eTag) {
    this.status = status;
    this.responseBody = responseBody;
    this.eTag = eTag;
  }

  FetchResult.success = function (responseBody, eTag) {
    return new FetchResult(FetchStatus.Fetched, responseBody, eTag);
  };

  FetchResult.notModified = function () {
    return new FetchResult(FetchStatus.NotModified, "");
  };

  FetchResult.error = function () {
    return new FetchResult(FetchStatus.Errored, "");
  };

  return FetchResult;
}();

export { FetchResult };
export { ProjectConfig } from "./ProjectConfig";
export { OptionsBase, DataGovernance } from "./ConfigCatClientOptions";
export { User } from "./RolloutEvaluator";
export { FlagOverrides, MapOverrideDataSource, OverrideBehaviour } from "./FlagOverrides";